"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _widgetContainer = _interopRequireWildcard(require("@insided/deprecated-preact-components/widget-container"));

var _categories = require("@insided/shared/utils/categories");

var _TabTopicList = _interopRequireDefault(require("./TabTopicList"));

var _categories2 = _interopRequireDefault(require("./categories"));

var _classnames = _interopRequireDefault(require("classnames"));

var _axios = _interopRequireDefault(require("axios"));

var _zod = require("zod");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var widgetName = 'category_and_topics_stream_only';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-category_and_topics_stream_only';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  tabs: _zod.z.array(_zod.z.object({
    enabled: _zod.z.boolean(),
    collapsed: _zod.z.boolean(),
    phrase: _zod.z.union([_zod.z.string(), _zod.z.undefined()]),
    phrase_suffix: _zod.z.enum(['categories', 'unanswered', 'recent_active']),
    class: _zod.z.string()
  })),
  categories: _zod.z.array(_zod.z.string())
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;

// Create a function that will return an object where key is the id of Category when isContainer is false and value is array of ids on it's parents
var getCategoryParentMap = function getCategoryParentMap(categories) {
  var parentIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return categories.reduce(function (acc, category) {
    if (category.isContainer) {
      return _objectSpread(_objectSpread({}, acc), getCategoryParentMap(category.children, [].concat((0, _toConsumableArray2.default)(parentIds), [category.id])));
    } else {
      acc[category.id] = parentIds;
      return acc;
    }
  }, {});
};

var CategoryAndTopicsStream = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CategoryAndTopicsStream, _Component);

  var _super = _createSuper(CategoryAndTopicsStream);

  function CategoryAndTopicsStream(props) {
    var _window$localStorage$;

    var _this;

    (0, _classCallCheck2.default)(this, CategoryAndTopicsStream);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "STORAGE_POSTFIX", 'tabs-helper-homepage');
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "URLS", {
      categories: '#',
      unanswered: '/activity/unanswered',
      recent_active: '/activity/recent'
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "childrenToParentCategoryList", getCategoryParentMap(_this.props.categoriesV2));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "enabledTabs", _this.props.tabs.filter(function (tab) {
      return tab.enabled;
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setActiveTab", typeof window === 'undefined' ? 0 : parseInt((_window$localStorage$ = window.localStorage.getItem(_this.STORAGE_POSTFIX)) !== null && _window$localStorage$ !== void 0 ? _window$localStorage$ : '1') - 1);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      tabs: _this.enabledTabs,
      activeTab: _this.setActiveTab >= _this.enabledTabs.length ? 0 : _this.setActiveTab,
      unreadTopicsAndRepliesCount: null
    });
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.getCategoriesToBeDisplayed = _this.getCategoriesToBeDisplayed.bind((0, _assertThisInitialized2.default)(_this));
    _this.getCustomTabsComponents = _this.getCustomTabsComponents.bind((0, _assertThisInitialized2.default)(_this));
    _this.getTabsComponents = _this.getTabsComponents.bind((0, _assertThisInitialized2.default)(_this));
    _this.getCategoriesTabComponent = _this.getCategoriesTabComponent.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(CategoryAndTopicsStream, [{
    key: "handleChange",
    value: function handleChange(idx) {
      var _this2 = this;

      this.setState({
        activeTab: idx
      }, function () {
        if (typeof window === 'undefined') return;
        window.localStorage.setItem(_this2.STORAGE_POSTFIX, (_this2.state.activeTab + 1).toString());
      });
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var categoryIds, _yield$axios$get, data;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                categoryIds = (0, _categories.flattenCategoryList)(this.props.categoriesV2).map(function (category) {
                  return category.id.toString();
                });

                if (!this.props.displayUnreadPostCount) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 2;
                _context.next = 5;
                return _axios.default.get('/topic/unreadPostDataInReadableForums', {
                  params: {
                    topicIds: categoryIds
                  }
                });

              case 5:
                _yield$axios$get = _context.sent;
                data = _yield$axios$get.data;
                this.setState({
                  unreadTopicsAndRepliesCount: data
                });
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);
                this.setState({
                  unreadTopicsAndRepliesCount: null
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 10]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "getCategoriesToBeDisplayed",
    value: function getCategoriesToBeDisplayed() {
      var _this3 = this;

      var _this$props = this.props,
          _this$props$selectedC = _this$props.selectedCategoryList,
          selectedCategoryList = _this$props$selectedC === void 0 ? [] : _this$props$selectedC,
          categoriesV2 = _this$props.categoriesV2;
      var categoriesToBeDisplayed = categoriesV2;

      if (selectedCategoryList !== null && selectedCategoryList !== void 0 && selectedCategoryList.length) {
        // Including selected container category id, and it's all parent category ids
        var idOfCategoriesToBeDisplayed = (0, _toConsumableArray2.default)(new Set(selectedCategoryList.flatMap(function (categoryId) {
          return _this3.childrenToParentCategoryList[categoryId] || [];
        }))).concat(selectedCategoryList); // Filter categories to be displayed based on selected category list and it's parent categories

        var filteredCategories = function filteredCategories(categories, idsToDisplay) {
          return categories.reduce(function (acc, category) {
            if (idsToDisplay.includes(category.id)) {
              var filteredChildren = filteredCategories(category.children, idsToDisplay);
              acc.push(_objectSpread(_objectSpread({}, category), {}, {
                children: filteredChildren
              }));
            }

            return acc;
          }, []);
        };

        categoriesToBeDisplayed = filteredCategories(categoriesV2, idOfCategoriesToBeDisplayed);
      }

      return categoriesToBeDisplayed;
    }
  }, {
    key: "getCategoriesTabComponent",
    value: function getCategoriesTabComponent() {
      var _tabs$categoriesTabId;

      var _this$props2 = this.props,
          attachmentCdn = _this$props2.attachmentCdn,
          collapsed = _this$props2.collapsed,
          displayUnreadPostCount = _this$props2.displayUnreadPostCount;
      var _this$state = this.state,
          tabs = _this$state.tabs,
          unreadTopicsAndRepliesCount = _this$state.unreadTopicsAndRepliesCount;
      var categoriesTabIdx = tabs.findIndex(function (tab) {
        return tab.phrase_suffix === 'categories';
      });
      var categoriesToBeDisplayed = this.getCategoriesToBeDisplayed();
      return (0, _preact.h)(_categories2.default, {
        categoriesV2: categoriesToBeDisplayed,
        collapsed: collapsed !== null && collapsed !== void 0 ? collapsed : {},
        displayUnreadPostCount: displayUnreadPostCount,
        unreadTopicsAndRepliesCount: unreadTopicsAndRepliesCount,
        isDefaultCollapsed: ((_tabs$categoriesTabId = tabs[categoriesTabIdx]) === null || _tabs$categoriesTabId === void 0 ? void 0 : _tabs$categoriesTabId.collapsed) || false,
        attachmentCdn: attachmentCdn
      });
    }
  }, {
    key: "getCustomTabsComponents",
    value: function getCustomTabsComponents() {
      var customTabsData = this.props.customTabsData;
      if (!customTabsData) return {};
      var customTabsComponents = {};
      Object.keys(customTabsData).forEach(function (customTabPhraseSuffix) {
        var customTab = customTabsData[customTabPhraseSuffix];
        customTabsComponents[customTabPhraseSuffix] = (0, _preact.h)(_TabTopicList.default, customTab);
      });
      return customTabsComponents;
    }
  }, {
    key: "getTabsComponents",
    value: function getTabsComponents() {
      var _this$props3 = this.props,
          unAnsweredTopicsList = _this$props3.unAnsweredTopicsList,
          recentlyActiveTopicsList = _this$props3.recentlyActiveTopicsList;
      var customTabsComponents = this.getCustomTabsComponents();

      var COMPONENTS = _objectSpread({
        categories: this.getCategoriesTabComponent(),
        unanswered: (0, _preact.h)(_TabTopicList.default, unAnsweredTopicsList),
        recent_active: (0, _preact.h)(_TabTopicList.default, recentlyActiveTopicsList)
      }, customTabsComponents);

      return COMPONENTS;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var config = this.props.config;
      var title = config.title,
          subtitle = config.subtitle,
          backgroundColor = config.backgroundColor,
          backgroundColorDisplay = config.backgroundColorDisplay,
          hideSpacingWithUpperWidget = config.hideSpacingWithUpperWidget,
          paddingToTopAndBottom = config.paddingToTopAndBottom,
          titleColor = config.titleColor,
          titleColorDisplay = config.titleColorDisplay,
          subtitleColor = config.subtitleColor,
          subtitleColorDisplay = config.subtitleColorDisplay;
      var _this$state2 = this.state,
          tabs = _this$state2.tabs,
          activeTab = _this$state2.activeTab;
      var COMPONENTS = this.getTabsComponents();
      return (0, _preact.h)(_widgetContainer.default, {
        config: {
          title: title,
          subtitle: subtitle,
          backgroundColor: backgroundColor,
          backgroundColorDisplay: backgroundColorDisplay,
          hideSpacingWithUpperWidget: hideSpacingWithUpperWidget,
          paddingToTopAndBottom: paddingToTopAndBottom,
          titleColor: titleColor,
          titleColorDisplay: titleColorDisplay,
          subtitleColor: subtitleColor,
          subtitleColorDisplay: subtitleColorDisplay
        },
        widgetName: "category-and-topic-stream"
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('box', 'pagebox', 'box--unbox')
      }, (0, _preact.h)("div", {
        className: "box__content"
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('module', 'widget--tabs', 'tabs', 'qa-widget-tabs')
      }, (0, _preact.h)("nav", {
        className: "sections__nav sections__nav--accordion-S"
      }, (0, _preact.h)("div", {
        className: "tabs--nav__container"
      }, (0, _preact.h)("div", {
        className: "tabs--nav"
      }, (0, _preact.h)("ul", {
        className: "tabs--navigation qa-tabs-menu"
      }, tabs.map(function (tab, idx) {
        var _tab$phrase;

        return (0, _preact.h)("li", {
          key: tab.phrase_suffix,
          onKeyDown: function onKeyDown(e) {
            if (e.key === 'Enter') {
              _this4.handleChange(idx);
            }
          },
          className: (0, _classnames.default)('tabs__item', 'tabs__item--M', 'qa-tab'),
          onClick: function onClick() {
            return _this4.handleChange(idx);
          }
        }, (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)(_this4.URLS[tab.phrase_suffix]),
          onClick: function onClick(e) {
            return e.preventDefault();
          },
          className: "qa-link-tab js-tab ".concat(tab.class).concat(activeTab === idx ? ' is-active' : '')
        }, (_tab$phrase = tab.phrase) !== null && _tab$phrase !== void 0 ? _tab$phrase : (0, _preact.h)(_phrase.default, {
          p: "tab.navigation.".concat((tab.phrase_suffix || '').replace(' ', '_'))
        })));
      })))), (0, _preact.h)("div", {
        className: "tabs--navigation"
      }, tabs.map(function (tab, idx) {
        return (0, _preact.h)("div", {
          className: "tabs qa-tabs",
          key: tab.phrase
        }, (0, _preact.h)("div", {
          className: "js-content js-content-1 qa-tab-isVisible js-content-".concat(idx + 1).concat(activeTab !== idx ? ' is-hidden--loose' : '')
        }, COMPONENTS[tab.phrase_suffix]));
      }), (0, _preact.h)("div", {
        className: "tabs qa-tabs"
      })))))));
    }
  }]);
  return CategoryAndTopicsStream;
}(_preact.Component);

var _default = CategoryAndTopicsStream;
exports.default = _default;